import { useEffect, useState } from 'react';
import { useDatabase } from './useDatabase';

export interface ProblemDetails {
  id: string;
  title: string;
  description: string | undefined;
  reportedBy: string | undefined;
  resolved: boolean;
  resolvedAt: string | undefined;
  createdAt: string;
  updatedAt: string;
}

export function useProblem(problemId: string | undefined) {
  const { database, loading: databaseLoading } = useDatabase();
  const [problem, setProblem] = useState<ProblemDetails | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!database || !problemId) {
      if (!database) setLoading(false);
      return;
    }

    try {
      const problems = database.problems();
      const obj = problems[problemId];

      if (!obj) {
        setError(`Problem with ID ${problemId} not found`);
        setProblem(null);
      } else {
        setProblem({
          id: problemId,
          title: obj.title(),
          description: obj.description() ?? undefined,
          reportedBy: obj.reported_by() ?? undefined,
          resolved: obj.resolved(),
          resolvedAt: obj.resolved_at() ?? undefined,
          createdAt: obj.created_at(),
          updatedAt: obj.updated_at(),
        });
        setError(null);
      }
    } catch (err) {
      console.error('Error fetching problem:', err);
      setError(`Error fetching problem: ${err}`);
      setProblem(null);
    } finally {
      setLoading(false);
    }
  }, [database, problemId]);

  return { problem, loading: loading || databaseLoading, error };
}
